import React, { useState, useEffect } from "react";
import { baseUrl, config } from "../../../../services/config";
import { upperCase } from "lodash";
export default function PrintSchoolInvoice({ allInvoicesList, isCombine }) {
  let authtoken = localStorage.getItem("userToken");
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const [directorSign, setDirectorSign] = useState(0);

  useEffect(() => {
    getSettingData();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
        setDirectorSign(data.payload.settings.director_sign);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const todayDate = () => {
    let d = new Date();
    var curr_moth = ("0" + (d.getMonth() + 1)).slice(-2);
    var curr_date = ("0" + d.getDate()).slice(-2);
    let newdate = `${d.getFullYear()}-${curr_moth}-${curr_date}`;
    return newdate;
  };

  function inWords(num) {
    let a = [
      "",
      "One ",
      "Two ",
      "Three ",
      "Four ",
      "Five ",
      "Six ",
      "Seven ",
      "Eight ",
      "Nine ",
      "Ten ",
      "Eleven ",
      "Twelve ",
      "Thirteen ",
      "Fourteen ",
      "Fifteen ",
      "Sixteen ",
      "Seventeen ",
      "Eighteen ",
      "Nineteen ",
    ];

    let b = [
      "",
      "",
      "Twenty ",
      "Thirty ",
      "Forty ",
      "Fifty ",
      "Sixty ",
      "Seventy ",
      "Eighty ",
      "Ninety ",
    ];

    if ((num = num.toString()).length > 9) return "Overflow";

    let n = ("000000000" + num)
      .slice(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    if (!n) return "";

    let str = "";

    str += n[1] != 0 ? (a[n[1]] || b[n[1][0]] + a[n[1][1]]) + "Crore " : "";

    str += n[2] != 0 ? (a[n[2]] || b[n[2][0]] + a[n[2][1]]) + "Lakh " : "";

    str += n[3] != 0 ? (a[n[3]] || b[n[3][0]] + a[n[3][1]]) + "Thousand " : "";

    str += n[4] != 0 ? a[n[4]] + "Hundred " : "";

    str +=
      n[5] != 0
        ? (str !== "" ? "And " : "") +
          (a[n[5]] || b[n[5][0]] + a[n[5][1]]) +
          "Only"
        : "Only";

    return str.trim();
  }

  const getMonthName = (date) => {
    if (date == "") {
      return "_";
    }
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}, ${d.getFullYear()}`;
  };
  return (
    <div style={{ visibility: "hidden" }}>
      <>
        {allInvoicesList.length > 0 &&
          allInvoicesList.map((invoice, index) => (
            <div
              style={{
                pageBreakAfter:
                  index === allInvoicesList.length - 1 ? "auto" : "always",
              }}
            >
              <div className="page1-content" key={index}>
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <img
                    src={icon}
                    style={{ height: 120, width: 110 }}
                    alt="icon"
                  />
                  <div>
                    <h1
                      style={{
                        color: "black",
                        paddingLeft: "10px",
                        paddingTop: "25px",
                        fontSize: "35px",
                      }}
                    >
                      {unitName}
                    </h1>
                    <h2
                      style={{
                        color: "black",
                        paddingLeft: "10px",
                      }}
                    >
                      Monthly Inovice Payment
                    </h2>
                  </div>
                </div>
                <div className="d-flex justify-content-between mt-5">
                  <h5
                    style={{
                      fontSize: "19px",
                      whiteSpace: "normal",
                      padding: "1px",
                      color: "black",
                    }}
                  >
                    <b>School Name :- &nbsp;</b>
                    {isCombine
                      ? invoice?.school_name
                      : invoice?.school_account?.school_name}
                  </h5>
                  <h5
                    style={{
                      fontSize: "19px",
                      whiteSpace: "normal",
                      padding: "1px",
                      color: "black",
                    }}
                  >
                    <b>Financial Year :-</b> &nbsp;{" "}
                    {isCombine && Array.isArray(invoice?.invoices)
                      ? invoice?.invoices[0]?.session?.year
                      : invoice?.session?.year}
                  </h5>
                </div>

                <div className="d-flex justify-content-between mb-5">
                  <h5
                    style={{
                      fontSize: "19px",
                      whiteSpace: "normal",
                      padding: "1px",
                      color: "black",
                    }}
                  >
                    <b>Region Name :- &nbsp;</b>
                    {isCombine
                      ? invoice?.region_name
                      : invoice?.school_account?.region?.name}
                  </h5>
                  <h5
                    style={{
                      fontSize: "19px",
                      whiteSpace: "normal",
                      padding: "1px",
                      color: "black",
                    }}
                  >
                    <b>Printing Date :-</b> &nbsp; {todayDate()}
                  </h5>
                </div>
                <table
                  className="page1-table"
                  style={{
                    fontSize: "20px",
                    whiteSpace: "normal",
                    padding: "1px",
                    // marginTop: "-40px",
                  }}
                >
                  <tr
                    className="page1-tr"
                    style={{
                      fontSize: "19px",
                      whiteSpace: "normal",
                      padding: "1px",
                    }}
                  >
                    <th
                      style={{
                        textAlign: "center",
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        // width: "4%",
                      }}
                      className="page1-th"
                    >
                      Sr.#
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        // width: "66%",
                      }}
                      className="page1-th"
                    >
                      Invoice No.
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        // width: "66%",
                      }}
                      className="page1-th"
                    >
                      Month
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        // width: "66%",
                      }}
                      className="page1-th"
                    >
                      Description
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        // width: "10%",
                      }}
                      className="page1-th"
                    >
                      Paid
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        // width: "10%",
                      }}
                      className="page1-th"
                    >
                      Balance
                    </th>
                  </tr>
                  {isCombine ? (
                    invoice?.invoices?.map((invoice, index) => (
                      <tr
                        className="page1-tr"
                        style={{
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        <td
                          style={{
                            textAlign: "center",
                            color: "black",
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="page1-td"
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            color: "black",
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="page1-td"
                        >
                          {invoice?.invoice_number}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            color: "black",
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="page1-td"
                        >
                          {getMonthName(invoice?.month)}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            color: "black",
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="page1-td"
                        >
                          {Array.isArray(invoice?.invoice_details) &&
                            invoice?.invoice_details[0]?.description}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            color: "black",
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="page1-td"
                        >
                          {Intl.NumberFormat("en-Us").format(invoice?.paid)}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            color: "black",
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="page1-td"
                        >
                          {Intl.NumberFormat("en-Us").format(invoice?.balance)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr
                      className="page1-tr"
                      style={{
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                    >
                      <td
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-td"
                      >
                        1
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-td"
                      >
                        {invoice?.invoice_number}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-td"
                      >
                        {getMonthName(invoice?.month)}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-td"
                      >
                        {Array.isArray(invoice?.invoice_details) &&
                          invoice?.invoice_details[0]?.description}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-td"
                      >
                        {Intl.NumberFormat("en-Us").format(invoice?.paid)}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          color: "black",
                          fontSize: "16px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-td"
                      >
                        {Intl.NumberFormat("en-Us").format(invoice?.balance)}
                      </td>
                    </tr>
                  )}

                  <tr
                    style={{
                      color: "black",
                      whiteSpace: "normal",
                      padding: "1px",
                    }}
                  >
                    <td
                      style={{
                        color: "black",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                      className="page1-td"
                    ></td>
                    <td
                      colSpan={3}
                      className="page1-td text-right"
                      style={{
                        color: `${config.txtColor}`,
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        fontWeight: "bold",
                        paddingRight: "30px",
                      }}
                    >
                      <label style={{ lineHeight: "1.35" }}>
                        {"Total Amount: " +
                          inWords(
                            parseInt(
                              isCombine
                                ? invoice?.total_payable
                                : invoice?.payable,
                            ),
                          )}
                      </label>
                    </td>
                    <td
                      className="page1-td text-center"
                      style={{
                        color: `${config.txtColor}`,
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        fontWeight: "bold",
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        isCombine ? invoice?.total_paid : invoice?.paid,
                      )}
                    </td>
                    <td
                      className="page1-td text-center"
                      style={{
                        color: `${config.txtColor}`,
                        whiteSpace: "normal",
                        padding: "1px",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        isCombine ? invoice?.total_balance : invoice?.balance,
                      )}
                    </td>
                    {/* <td className="page1-td"></td> */}
                  </tr>
                </table>
                {/* <div className="lower-content">
                  <div className="lower1">
                    <div className="lower2">
                      <p style={{ fontSize: "1.5rem" }}>Prepared By</p>
                    </div>
                  </div>
                  <div className="lower1">
                    <div className="lower2">
                      <p style={{ fontSize: "1.5rem" }}>Accountant</p>
                    </div>
                  </div>
                  <div className="lower1" id="lowerLast">
                    <div className="lower2">
                      {directorSign == 0 ? (
                        <p style={{ fontSize: "1.5rem" }}>Chief Executive</p>
                      ) : (
                        <p style={{ fontSize: "1.5rem" }}>Director</p>
                      )}
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          ))}
      </>
    </div>
  );
}
